import { html, View } from 'rune-ts';
import klass from './TabListView.module.scss';
import { font } from '@services/MarppleShop/shared/typography';
import { classes } from '@services/MarppleShop/shared/util';

type TProps = {
  tabs: {
    tab_title: string;
    selected: boolean;
    href: string;
  }[];
};

/**
 * https://www.figma.com/design/2M9d5FfwC5cighwGgLxqJN/MarppleShop-2.4?node-id=6690-353873&t=vIQjWGfCLPWFZEV5-0
 */
export class TabListView extends View<TProps> {
  protected override template({ tabs }: TProps) {
    return html`<ul class="${klass.tab_list}">
      ${tabs.map(
        ({ tab_title, selected, href }) =>
          html`<li>
            <a class="${klass.tab_mo}" href="${href}">
              <span
                class="${classes(font(selected ? '16_bold' : '16_medium'), klass.tab_title, {
                  [klass.selected]: selected,
                })}"
              >
                ${tab_title}
              </span>

              ${selected ? html`<div class="${klass.line}"></div>` : null}
            </a>
          </li>`,
      )}
    </ul>`;
  }
}
